export default __webpack_public_path__ + "static/media/html_icon.bfe202ac.svg";